export default "__VITE_ASSET__mwmFD4ck__"